import React from "react";
import { NavBar } from "../../common/NavBar";
import { OnvifScanScreen } from "./OnvifScanScreen";
import { useOnvifScanStore } from "./onvifScanStore/onvifScanStore";
import { OnvifScanMode } from "./OnvifScanUtils/onvifScanInterfaces";

type Dispatcher<S> = React.Dispatch<React.SetStateAction<S>>;

export const OnvifScan = ({
  navBarCollapsed,
  setNavBarCollapsed,
  mode = "discover",
}: {
  navBarCollapsed: boolean;
  setNavBarCollapsed: Dispatcher<boolean>;
  /** Route-selected: sites/:siteId/onvifscan = discover, …/unitscan = update. */
  mode?: OnvifScanMode;
}) => {
  const reset = useOnvifScanStore((state) => state.reset);
  const setMode = useOnvifScanStore((state) => state.setMode);

  // Start each visit from a clean slate (no stale hosts/selection).
  React.useEffect(() => {
    reset();
    setMode(mode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);

  return (
    <div>
      <div className="bg-actuate-grey absolute w-full h-full overflow-scroll">
        <div
          className={
            !navBarCollapsed ? "pl-[170px] pt-[10px]" : "pl-[95px] pt-[10px]"
          }
        >
          <OnvifScanScreen mode={mode} />
        </div>
      </div>
      <div className="justify-start">
        <NavBar
          navBarCollapsed={navBarCollapsed}
          setNavBarCollapsed={setNavBarCollapsed}
          props={{}}
        />
      </div>
    </div>
  );
};
